import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const NonDatasourceFieldDetailsFragmentGql: DocumentNode = gql`
fragment NonDatasourceFieldDetailsFragment on Field {
  id
  name
  description
  folderName
  isHidden
  fullyQualifiedName
  # Bin, Calculated, Combined, CombinedSet, Group, Hierarchy, or Set
  ... on FieldReferencingField {
    fieldsConnection {
      totalCount
    }
  }
  # Bin, Calculated, Column, or Group
  ... on DataField {
    dataCategory
    dataType
    role
  }
  # Calculated or Column
  ... on AnalyticsField {
    aggregation
    aggregationParam
    defaultFormat
    semanticRole
  }
  ... on BinField {
    binField: id
    binSize
    formula
    fields {
      id
      name
    }
    parameters {
      name
    }
  }
  ... on CalculatedField {
    calculatedField: id
    formula
    hasUserReference
    isAutoGenerated
    fields {
      id
      name
    }
    parameters {
      name
    }
  }
  ... on ColumnField {
    columnField: id
    columnsConnection {
      totalCount
      nodes {
        id
        name
        description
        table {
          id
          name
        }
        referencedByFlowColumnOutputField {
          parentFields {
            ... on FlowColumnInputField {
              column {
                id
                name
                description
                table {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
  ... on CombinedField {
    combinedField: id
  }
  ... on CombinedSetField {
    combinedSetField: id
    combinationType
    delimiter
  }
  ... on GroupField {
    groupField: id
    hasOther
    fieldsReferencedByGroup: fields {
      name
      ... on AnalyticsField {
        semanticRole
      }
    }
  }
  ... on HierarchyField {
    hierarchyField: id
  }
  ... on SetField {
    setField: id
  }
}
`;
